import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

type BarCorner = 'square' | 'soft' | 'round';
type BarThickness = 'thin' | 'normal' | 'thick';

interface BarStyleControlsProps {
    corner: BarCorner;
    thickness: BarThickness;
    gradient: boolean;
    disabled?: boolean;
    onCornerChange: (corner: BarCorner) => void;
    onThicknessChange: (thickness: BarThickness) => void;
    onGradientChange: (gradient: boolean) => void;
}

const CORNERS: { id: BarCorner; label: string }[] = [
    { id: 'square', label: 'Reto' },
    { id: 'soft', label: 'Suave' },
    { id: 'round', label: 'Arredondado' },
];

const THICKNESSES: { id: BarThickness; label: string }[] = [
    { id: 'thin', label: 'Finas' },
    { id: 'normal', label: 'Normais' },
    { id: 'thick', label: 'Grossas' },
];

const segmentClass = (active: boolean) =>
    cn(
        'flex-1 rounded-lg border px-2 py-1.5 text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        active
            ? 'border-blue-500 bg-blue-50/50 text-blue-700'
            : 'border-border text-foreground hover:bg-surface',
    );

/** Bar-chart appearance: corner shape, thickness preset and gradient fill. */
export default function BarStyleControls({
    corner,
    thickness,
    gradient,
    disabled = false,
    onCornerChange,
    onThicknessChange,
    onGradientChange,
}: BarStyleControlsProps) {
    return (
        <div>
            <label className="mb-2 block text-sm font-medium text-foreground">
                Estilo das barras
            </label>
            <div className="flex gap-1.5">
                {CORNERS.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        disabled={disabled}
                        aria-pressed={corner === option.id}
                        onClick={() => onCornerChange(option.id)}
                        className={segmentClass(corner === option.id)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            <div className="mt-1.5 flex gap-1.5">
                {THICKNESSES.map((option) => (
                    <button
                        key={option.id}
                        type="button"
                        disabled={disabled}
                        aria-pressed={thickness === option.id}
                        onClick={() => onThicknessChange(option.id)}
                        className={segmentClass(thickness === option.id)}
                    >
                        {option.label}
                    </button>
                ))}
            </div>
            <label className="mt-2 flex cursor-pointer items-center gap-2.5 text-sm text-foreground">
                <Checkbox
                    checked={gradient}
                    disabled={disabled}
                    onCheckedChange={(value) => onGradientChange(value === true)}
                />
                Preenchimento em degradê
            </label>
        </div>
    );
}
